'use client';

import './global.css'
import Image from 'next/image';
import Link from 'next/link';
import { Nav } from '@/components/nav';
import DatadogInit from '@/lib/datadog-init';

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <html lang="en">
      <body className="min-h-screen flex flex-col bg-primary-foreground">
        <DatadogInit />
        <Nav />
        <main className="w-full flex flex-col flex-1">
          {children}
        </main>
        <footer className="text-white justify-center">
          <div className="bg-primary flex justify-center">
            <div className="max-w-6xl w-full py-4 px-4 md:px-0 flex flex-col md:flex-row">
              <div className="flex flex-col flex-[1_1_40%] space-y-4 text-center md:text-left">
                <p className="text-xs">
                  Vertical Insure, Inc. is a licensed insurance producer in the states where it transacts insurance.
                </p>
                <p className="text-xs">
                  Vertical Insure, Inc. is doing business as Vertical Insurance Services in New York and as Vertical Software Insurance Services in California state.
                </p>
                <p className="text-xs">
                  Vertical Insure operates as Saas Insure Services Inc. in Canada, BN 718834146.
                </p>
                <p className="text-xs">
                  Next Wave Insurance Services, LLC is a wholly owned subsidiary of Vertical Insure, Inc., and operates as Vertical Insure, Inc. licensed insurance producer in the states where it transacts insurance.
                </p>
              </div> 
              <div className="flex-1 flex justify-center md:justify-end">
                <Link href="https://www.verticalinsure.com"><Image src="https://brand.verticalinsure.com/assets/vertical-Insure-light-blue.png" width={200} height={77} alt="Vertical Insure Logo" className="h-auto object-contain w-[200px]" style={{height: 'auto'}} /></Link>
              </div>
              
            </div>
          </div>
          <div className="bg-stone-800 flex justify-center">
            <div className="max-w-6xl w-full py-4 text-white">
              <nav className="flex flex-col md:flex-row items-center gap-1 md:gap-3 text-xs">
                <p className="text-sm">Copyright © 2024 Vertical Insure, Inc. All right reserved.</p>
                <Link className="text-secondary underline hover:no-underline" href="https://www.verticalinsure.com/legal/terms-and-conditions">Terms and Conditions</Link>
                <Link className="text-secondary underline hover:no-underline" href="https://www.verticalinsure.com/legal/privacy-policy">Privacy Policy</Link>
              </nav>
            </div>
          </div>
        </footer>
      </body>
    </html>
  )
}
